import { useEffect } from "react";

const Home = () => {
  useEffect(() => {
    function createParticle() {
      const particle = document.createElement("div");
      particle.className = "particle";
      particle.style.width = Math.random() * 4 + 1 + "px";
      particle.style.height = particle.style.width;
      particle.style.background = "rgba(255, 255, 255, 0.5)";
      particle.style.borderRadius = "50%";
      particle.style.left = Math.random() * window.innerWidth + "px";
      particle.style.top = window.innerHeight + "px";
      document.body.appendChild(particle);

      const duration = Math.random() * 10 + 10;
      particle.animate(
        [
          { transform: "translateY(0) translateX(0)" },
          {
            transform: `translateY(-${window.innerHeight + 100}px) translateX(${
              Math.random() * 200 - 100
            }px)`,
          },
        ],
        {
          duration: duration * 1000,
          easing: "linear",
        }
      ).onfinish = () => particle.remove();
    }

    // Create particles periodically
    setInterval(createParticle, 500);

    // Smooth scroll for contact link

    // Add parallax effect on mouse move
    document.addEventListener("mousemove", (e) => {
      const orbs = document.querySelectorAll(".orb");
      const x = e.clientX / window.innerWidth;
      const y = e.clientY / window.innerHeight;

      orbs.forEach((orb, index) => {
        const speed = (index + 1) * 20;
        orb.style.transform = `translate(${x * speed}px, ${y * speed}px)`;
      });
    });
  }, []);
  return (
    <div className="App">
      <div className="background-animation">
        <div className="orb orb1"></div>
        <div className="orb orb2"></div>
        <div className="orb orb3"></div>
      </div>

      <div className="glass-overlay"></div>
      <div className="container">
        <section className="hero">
          <h1 className="heading">Kozidev</h1>
          <p className="subheading">Coming soon</p>
          <p className="subheading">
            For queries, contact support@kozidevtech.com
          </p>
        </section>
      </div>
    </div>
  );
};

export default Home;
